import type { Event } from '@patsnap/tahiti-core';
import type { EmbodimentState } from '../types';

/**
 * 实施例服务
 * 用于管理实施例的生成和更新
 */
export const EmbodimentService = Symbol.for('EmbodimentService');

export interface EmbodimentService {
    /**
     * 状态变更事件
     * 当实施例状态发生变化时触发
     */
    readonly onStateChange: Event<EmbodimentState>;

    /**
     * 获取当前模型数据
     * @returns 实施例状态
     */
    getModelData(): EmbodimentState;

    /**
     * 生成实施例
     * 根据配置的规则生成新的实施例
     */
    generateEmbodiment(): Promise<void>;

    /**
     * 更新实施例内容
     * @param content - 新的实施例内容
     */
    updateEmbodimentContent(content: string): void;

    /**
     * 重置实施例
     * 清空当前实施例内容
     */
    resetEmbodiment(): void;
}
